import { normalizeRut } from '@/utils/rut';
import type { ValidatedCreateCompanyFormData, LC_CreateCompanyIn } from '../types';

/**
 * Mapea los datos del formulario UI (ya validados por Zod) al formato de transporte para el backend
 * - Separa RUT en cuerpo (companyRUT) y dígito verificador (companyDV)
 * - Convierte strings vacíos a null para campos opcionales
 * - Maneja validaciones condicionales (REX fields solo si synchronizeWithREX=true)
 */
export function mapCreateCompanyFormToTransport(
  formData: ValidatedCreateCompanyFormData,
): LC_CreateCompanyIn {
  // Normalizar RUT y separar en cuerpo + dv
  const normalizedRut = normalizeRut(formData.rutComplete);
  const companyRUT = normalizedRut.slice(0, -1); // Todos menos el último carácter
  const companyDV = normalizedRut.slice(-1).toUpperCase(); // Último carácter (DV)

  return {
    companyRUT,
    companyDV,
    companyName: formData.companyName.trim(),
    companyNameFantasy: formData.companyNameFantasy?.trim() || null,
    terminateEmployeesWithExpiredContract: formData.terminateEmployeesWithExpiredContract,
    synchronizeWithREX: formData.synchronizeWithREX,
    rexid: formData.synchronizeWithREX ? (formData.rexid?.trim() || null) : null,
    rexurl: formData.synchronizeWithREX ? (formData.rexurl?.trim() || null) : null,
    companyAddress: formData.companyAddress?.trim() || null,
    companyAddressNumber: formData.companyAddressNumber.trim(),
    companyAddressRegionId: formData.regionId,
    companyAddressCommuneId: formData.communeId,
    fatherCompanyId: formData.fatherCompanyId,
    estCompanyType: formData.estCompanyType || null,
    hasAttendanceIntengrationREX: false,
    namePersonContact: formData.namePersonContact?.trim() || null,
    emailPersonContact: formData.emailPersonContact?.trim() || null,
    telephonePersonContact: formData.telephonePersonContact?.trim() || null,
  };
}
